import { EUpperCountries } from 'types/commonEnums';

export const COUNTRIES_DATA = [
  { id: 1, description: EUpperCountries.US },
  { id: 2, description: EUpperCountries.CA },
  { id: 3, description: 'Europe' },
  { id: 4, description: EUpperCountries.UK },
  { id: 5, description: EUpperCountries.AU },
  { id: 6, description: 'Asia' },
];

export const COUNTRIES_SHIP_FROM = [
  { id: 2, description: EUpperCountries.US },
  { id: 3, description: EUpperCountries.CN },
  { id: 4, description: EUpperCountries.AU },
  { id: 5, description: EUpperCountries.CA },
  { id: 6, description: EUpperCountries.DE },
  { id: 7, description: EUpperCountries.ES },
  { id: 8, description: EUpperCountries.FR },
  { id: 9, description: EUpperCountries.IT },
  { id: 10, description: EUpperCountries.UK },
  { id: 11, description: EUpperCountries.PL },
  { id: 12, description: EUpperCountries.RU },
  { id: 13, description: EUpperCountries.BE },
  { id: 14, description: EUpperCountries.NL },
];

interface IProductSourcesData {
  id: number,
  description: string,
}

export const PRODUCT_SOURCES_DATA: IProductSourcesData[] = [
  { id: 1, description: 'Dropshipping' },
  { id: 2, description: 'Dropshipping Aggregator' },
  { id: 3, description: 'Manufacturer' },
  { id: 4, description: 'Warehouse' },
  { id: 5, description: 'Other' },
];

export const PROCESSING_TIME_DATA = [
  { id: 1, dayFrom: 1, dayTo: 2, description: '1-2 Business Days' },
  { id: 2, dayFrom: 3, dayTo: 4, description: '3-4 Business Days' },
  { id: 3, dayFrom: 5, dayTo: 7, description: '5-7 Business Days' },
  { id: 4, dayFrom: 7, dayTo: 9999, description: 'more than 7 Days' },
];

interface IShippingTimeData {
  id: number,
  dayFrom: number,
  dayTo: number,
  description: string,
}

export const SHIPPING_TIME_DATA: IShippingTimeData[] = [
  { id: 1, dayFrom: 1, dayTo: 2, description: '1-2' },
  { id: 2, dayFrom: 3, dayTo: 4, description: '3-4' },
  { id: 3, dayFrom: 5, dayTo: 7, description: '5-7' },
  { id: 5, dayFrom: 8, dayTo: 10, description: '8-10' },
  { id: 6, dayFrom: 11, dayTo: 14, description: '11-14' },
  { id: 7, dayFrom: 15, dayTo: 20, description: '15-20' },
  { id: 8, dayFrom: 21, dayTo: 30, description: '21-30' },
];

export const RESTRICTED_MARKETPLACES_DATA = [
  { id: 1, name: 'Amazon' },
  { id: 2, name: 'AliExpress' },
  { id: 3, name: 'Banggood' },
  { id: 4, name: 'Walmart' },
  { id: 5, name: 'The Home Depot' },
  { id: 6, name: 'Wayfair' },
  { id: 7, name: 'Costco' },
  { id: 8, name: 'Overstock' },
  { id: 9, name: 'Costway' },
  { id: 10, name: 'Chinabrands' },
  { id: 11, name: 'Etsy' },
  { id: 12, name: 'Lowers' },
  { id: 13, name: 'eBay' },
  { id: 14, name: 'Target' },
  { id: 15, name: 'CJDropshipping' },
  { id: 16, name: 'Sam’s Club' },
  { id: 17, name: 'Vidaxl' },
  { id: 18, name: 'Gearbest' },
  { id: 19, name: 'MiniInTheBox' },
  { id: 20, name: 'LightInTheBox' },
  { id: 21, name: 'Alibaba' },
  { id: 22, name: 'Pureformulas' },
  { id: 23, name: 'Redbubble' },
  { id: 24, name: 'Wish' },
];

export const SELLING_COUNTRIES_DATA = [
  { id: 1, description: 'Amazon' },
  { id: 2, description: 'eBay' },
  { id: 3, description: 'Walmart' },
  { id: 4, description: 'Shopify' },
  { id: 5, description: 'Wix' },
  { id: 6, description: 'WooCommerce' },
  { id: 7, description: 'Ecwid' },
  { id: 8, description: 'Private Site' },
  { id: 9, description: 'OnBuy' },
  { id: 10, description: 'Newegg' },
  { id: 11, description: 'CDiscount' },
  { id: 12, description: 'Other' },
];

export const PAYS_FOR_SHIPPING_DATA = [
  { id: 1, key: 'buyer', description: 'Customers' },
  { id: 2, key: 'seller', description: 'Supplier' },
];

export const RETURN_WINDOW_TIME_DATA = [
  { id: 1, key: 'fourteen_d', value: 14, metric: 'day', description: '14 days' },
  { id: 2, key: 'thirty_d', value: 30, metric: 'day', description: '30 days' },
  { id: 3, key: 'sixty_d', value: 60, metric: 'day', description: '60 days' },
];
